import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum";
import { defineResources } from "jadro-pico-app/Resources/defineResources";

export const LoginResources = defineResources({
  [LanguageEnum.CS]: {
    title: "Přihlaš se",
    subtitle: "Použij účet pičo",
    username: "Uživatelské jméno",
    password: "Heslo",
    login: "Přihlásit",
  },
  [LanguageEnum.EN]: {
    title: "Sign in",
    subtitle: "Use your pičo account",
    username: "Username",
    password: "Password",
    login: "Log in",
  },
});

export const DashboardResources = defineResources({
  [LanguageEnum.CS]: {
    title: "Apky Pičo",
  },
  [LanguageEnum.EN]: {
    title: "Pičo Apps",
  },
});

export const ProfileResources = defineResources({
  [LanguageEnum.CS]: {
    title: "Profil",
    username: "Uživatelské jméno",
    email: "E-mail",
    logout: "Odhlásit",
  },
  [LanguageEnum.EN]: {
    title: "Profile",
    username: "Username",
    email: "Email",
    logout: "Log out",
  },
});
